import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ releaseNumber: string }>;

export const DispatchReleaseNumber: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/ReleaseNumber",
        releaseNumber: props.parameter.releaseNumber,
    });
};

export const chain = [DispatchReleaseNumber];

const setReleaseNumber = createHandlerChainRunner(chain, "ReleaseNumber");
export default setReleaseNumber;
